module.exports = __webpack_public_path__ + "img/exclamation-triangle.dbbdfe50.svg";